import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Div, Media, Text } from '@pezeshk-book/ui-kit';
import { FaqServicesProps } from './faq-services.props';
import QuestionIcon from '@icons-components/question-icon';

const Faq = ({ faqData }: FaqServicesProps) => {
  return (
    <>
      {faqData.map((item: { question: string, answer: string}, index) => {
        return (
          <Div itemScope itemProp={'mainEntity'} itemType={'https://schema.org/Question'} className={'relative p-0 gap-3 mb-4'} key={`faq_${index}`}>
            <Media greaterThan={'xs'}>
              <Div className={'bg-primary rounded-lg min-w-12 w-12 h-12 md:h-16 md:w-16 md:min-w-16 items-center justify-center shadow-lg relative'}>
                <Div className={'relative w-3 h-6 scale-x-[-1]'}>
                  <QuestionIcon/>
                </Div>
              </Div>
            </Media>
            <Accordion className={'shadow-lg !bg-primary-50 group !px-2 sm:!px-4 flex content-center'} rounded={'medium'} color={'primary'}>
              <AccordionSummary className={'justify-between group-open:items-baseline md:group-open:items-center relative group-open:pt-2 md:group-open:pt-0'}>
                <Text itemProp={'name'} align={'start'} type={'bold'} color={'inherit'} className={'truncate group-open:whitespace-normal'}>
                  {item.question}
                </Text>
              </AccordionSummary>
              <AccordionDetails className={'md:p-3 p-2 mt-3 md:mt-6'}>
                <Div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <Text itemProp="text" align={'justify'} typography={'xs'}>
                    {item.answer}
                  </Text>
                </Div>
              </AccordionDetails>
            </Accordion>
          </Div>
        );
      })}
    </>
  );
};

export default Faq;
